<template>
  <div class="w-full">
    <div class="hidden lg:block">
      <div class="flex mt-3 items-center lg:flex-col lg:justify-start lg:items-start lg:mt-0">
        <div class="flex justify-between w-full">
          <span class="block w-full text-sm">
            Huidig bod:
          </span>
          <AuctionFavorite :auction="item" />
        </div>
        <span
          v-if="item.bids.data.length === 0"
          class="block w-full text-gray-500 text-xs"
        >
          Door: --
        </span>
        <span
          v-else
          class="block w-full text-gray-500 text-xs"
        >
          Door: {{ item.bids.data[0].name }} om {{ item.bids.data[0].time }}
        </span>

        <div class="flex justify-between items-center w-full">
          <span
            v-if="item.bids.data.length === 0"
            class="text-sky-400 text-3xl font-bold lg:text-4xl mt-2"
          >
            &euro; --
          </span>
          <span
            v-else
            class="text-sky-400 text-3xl font-bold lg:text-4xl mt-2"
          >
            {{ formatMoney(item.bids.data[0].amount) }}
          </span>

          <template v-if="item.label === 'A-GRADE'">
            <span class="px-1 border border-gray-400 bg-gray-100 text-sm text-gray-350 uppercase"><span class="text-green-500">A</span>-Grade</span>
          </template>
          <template v-else-if="item.label === 'B-GRADE'">
            <span class="px-1 border border-gray-400 bg-gray-100 text-sm text-gray-350 uppercase"><span class="text-yellow-500">B</span>-Grade</span>
          </template>
          <template v-else-if="item.label === 'C-GRADE'">
            <span class="px-1 border border-gray-400 bg-gray-100 text-sm text-gray-350 uppercase"><span class="text-pink-400">C</span>-Grade</span>
          </template>
          <template v-else-if="item.label === 'D-GRADE'">
            <span class="px-1 border border-gray-400 bg-gray-100 text-sm text-gray-350 uppercase"><span class="text-red-500">D</span>-Grade</span>
          </template>
          <template v-else>
            <span class="px-1 border border-gray-400 bg-gray-100 text-sm text-gray-350 uppercase">{{ item.label }}</span>
          </template>
        </div>

        <div class="text-sky-400 text-xs mt-1 lg:hidden">
          <span class="w-full block">
            {{ closingTime }}
          </span>
          <i class="far fa-clock text-[.7rem] -mt-0.5" />
          <span
            v-if="item.ending_handled"
            class="inline font-bold"
          >
            Veiling is afgelopen
          </span>
          <span
            v-else-if="item.is_ending"
            class="inline font-bold"
          >
            Veiling toewijzen
          </span>
          <span
            v-else
            class="inline font-bold"
          >
            Nog: {{ timeLeftToText }}
          </span>
        </div>
      </div>
    </div>

    <div class="">
      <div class="text-right mb-1 lg:hidden">
        <template v-if="item.label === 'A-GRADE'">
          <span class="px-1 border border-gray-400 bg-gray-100 text-sm text-gray-350 uppercase"><span class="text-green-500">A</span>-Grade</span>
        </template>
        <template v-else-if="item.label === 'B-GRADE'">
          <span class="px-1 border border-gray-400 bg-gray-100 text-sm text-gray-350 uppercase"><span class="text-yellow-500">B</span>-Grade</span>
        </template>
        <template v-else-if="item.label === 'C-GRADE'">
          <span class="px-1 border border-gray-400 bg-gray-100 text-sm text-gray-350 uppercase"><span class="text-pink-400">C</span>-Grade</span>
        </template>
        <template v-else-if="item.label === 'D-GRADE'">
          <span class="px-1 border border-gray-400 bg-gray-100 text-sm text-gray-350 uppercase"><span class="text-red-500">D</span>-Grade</span>
        </template>
        <template v-else>
          <span class="px-1 border border-gray-400 bg-gray-100 text-sm text-gray-350 uppercase">{{ item.label }}</span>
        </template>
      </div>

      <div class="flex space-x-3 mb-1 md:space-x-0 md:flex-wrap">
        <div class="w-1/3 flex items-center justify-end lg:w-full lg:justify-start">
          Uw bod:
        </div>

        <div class="w-2/3 flex pl-1 md:pl-3 lg:pl-0 space-x-2 lg:w-full">
          <div :class="enableAutobid ? 'w-1/2' : 'w-full'">
            <input
              v-model="currentBid"
              type="number"
              :placeholder="formatMoney(nextMinimalBid)"
              :disabled="!enableAutobid"
              class="w-full placeholder-gray-500 text-black outline-none focus-within:border-sky-400 rounded border border-gray-300"
              :class="{'bg-gray-300 cursor-not-allowed': !enableAutobid}"
            >
          </div>

          <div
            v-if="enableAutobid"
            class="w-1/2 flex items-center space-x-1 "
          >
            <a
              href="javascript:void(0);"
              class="w-1/2 bg-orange-500 rounded text-white text-sm text-center pt-1.5 pb-0.5 hover:bg-orange-600"
              @click="raiseLow"
            >
              + {{ formatMoney(item.bidding_raise_low, true) }}
            </a>
            <a
              href="javascript:void(0);"
              class="w-1/2 bg-sky-400 rounded text-white text-sm text-center pt-1.5 pb-0.5 hover:bg-sky-500"
              @click="raiseHigh"
            >
              + {{ formatMoney(item.bidding_raise_high, true) }}
            </a>
          </div>
        </div>
      </div>

      <a
        v-if="hasWon"
        href="javascript:void(0);"
        class="bg-sky-200 block text-white font-bold rounded-lg py-2 w-full text-center lg:py-3 lg:mt-3 lg:mb-1 cursor-default"
      >
        <i class="far fa-clock text-sm mr-2 text-white" />
        Gewonnen
      </a>
      <a
        v-else-if="item.ending_handled"
        href="javascript:void(0);"
        class="bg-sky-200 block text-white font-bold rounded-lg py-2 w-full text-center lg:py-3 lg:mt-3 lg:mb-1 cursor-default"
      >
        <i class="far fa-clock text-sm mr-2 text-white" />
        Afgelopen
      </a>
      <a
        v-else-if="item.is_ending"
        href="javascript:void(0);"
        class="bg-sky-200 block text-white font-bold rounded-lg py-2 w-full text-center lg:py-3 lg:mt-3 lg:mb-1 cursor-not-allowed"
      >
        <i class="fa fa-spinner fa-spin text-sm mr-2 text-white" />
        Toewijzen
      </a>
      <a
        v-else-if="autoBid !== null"
        href="javascript:void(0);"
        class="bg-gray-500 hover:bg-gray-600 block text-white font-bold rounded-lg py-2 w-full text-center lg:py-3 lg:mt-3 lg:mb-1"
      >
        <i class="fas fa-gavel text-lg mr-2 text-white" />
        Autobod: {{ formatMoney(autoBid) }}
        <i
          class="fa fa-times text-white"
          @click="deleteAutoBid"
        />
      </a>
      <a
        v-else
        href="javascript:void(0);"
        class="bg-green-500 hover:bg-green-600 block text-white font-bold rounded-lg py-2 w-full text-center lg:py-3"
        @click="bidOnAuction"
      >
        <i class="fas fa-gavel text-lg mr-2 text-white" />
        Plaats bod
      </a>

      <!-- eslint-disable vue/no-v-html -->
      <span
        class="text-xs text-gray-500 block text-center mt-2 lg:text-left"
        v-html="shippingText"
      />
      <!-- eslint-enable vue/no-v-html -->
    </div>

    <template v-if="!hideBids">
      <div class="lg:hidden">
        <div class="border-b border-gray-200 w-full my-4" />
        <div class="">
          <span class="font-bold block w-full">
            Laatste biedingen:
          </span>
          <span
            v-if="item.bids.data.length === 0"
            class="text-gray-500"
          >
            Er is nog niet geboden
          </span>

          <div
            v-else
            class="grid grid-cols-3 gap-2 mt-2"
          >
            <div
              v-for="bid in item.bids.data"
              :key="bid.id"
              class="text-center bg-gray-100 p-2 rounded"
              :class="{'text-gray-500' : !isOwn(bid.customer_id)}"
            >
              <span
                class="block w-full"
                :class="{'text-sky-400 font-bold' : isOwn(bid.customer_id)}"
              >
                {{ formatMoney(bid.amount) }}
              </span>
              <span class="block w-full text-xs">
                {{ bid.name }}
              </span>
              <span class="block w-full text-xs">
                {{ bid.time }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import Auction from '../../Mixins/Auction';
import AuctionFavorite from '../New/AuctionFavorite.vue';

export default {
  components: {
    AuctionFavorite,
  },

  mixins: [Auction],

  props: {
    hideBids: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  emits: ['auction-updated'],

  data() {
    return {
      placingBid: false,
    };
  },

  methods: {
    bidOnAuction () {
      if (this.placingBid)  {
        return;
      }

      this.placingBid = true;
      const bid = this.currentBid && this.currentBid.toString().includes('.') ? parseFloat(this.currentBid) : parseInt(this.currentBid);

      if (parseInt(bid) !== bid) {
        this.$eventHub.$emit('notification', 'warning', 'Alleen afgeronden bedragen worden geaccepteerd');
        return;
      }

      axios.post('/ajax/placebid', {amount: bid, auction_id: this.item.id})
        .then((response) => {
          this.$eventHub.$emit('auctions.handlers', 'favorite', this.item.id);

          if (response.data.bid.type) {
            this.$eventHub.$emit('notification', 'success', 'Uw auto bod is geplaatst!', true);
            this.$eventHub.$emit('auctions.handlers', 'autobid', this.item.id, bid);
          } else {
            this.item.favorite = true;
            this.$page.props.customer.number_of_favorites++;

            this.$eventHub.$emit('notification', 'success', 'Uw bod is geplaatst!', true);
          }

          if (response.data.auction) {
            Object.keys((response.data.auction)).forEach((auctionKey) => {
              this.item[auctionKey] = response.data.auction[auctionKey];
            });
          }
        })
        .catch((error) => {
          if ('response' in error && 'status' in error.response) {
            if (error.response.status === 403 || error.response.status === 401) {
              this.$eventHub.$emit('login');

              return;
            }

            if (error.response.status === 422) {
              this.$eventHub.$emit('notification', 'warning', error.response.data);

              return;
            }
          }

          this.$eventHub.$emit('notification', 'warning', 'Bieden is niet gelukt, probeer het later opnieuw');
        })
        .finally(() => {
          this.placingBid = false;
        });
    },

    deleteAutoBid() {
      axios.post('/ajax/delete-autobod', {auction_id: this.item.id}).then(({data}) => {
        this.autoBid = null;
        this.$eventHub.$emit('notification', 'success', 'Uw autobod is verwijderd!');

        Object.keys((data.auction)).forEach((auctionKey) => {
          this.item[auctionKey] = data.auction[auctionKey];
        });
      });
    },

    auctionUpdatedEventCallback(auction) {
      this.$emit('auction-updated', auction);
    },
  },
};
</script>
